import axios from 'axios';
import store from '@/store';
import router from '@/router';
import { API_URL } from '@/config';

function isApiRequest(config) {
  return !!(config && config.url && config.url.indexOf(API_URL) === 0);
}

// แนบ token ทุกครั้งที่เรียก backend ของระบบ (ไม่แนบให้เว็บอื่น)
axios.interceptors.request.use(config => {
  const token = store.state.token;
  if (token && isApiRequest(config)) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// token หมดอายุหรือไม่ถูกต้อง (401): ออกจากระบบแล้วกลับหน้า login
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401 && isApiRequest(error.config)) {
      store.dispatch('logout').then(() => {
        if (router.currentRoute.path !== '/login') {
          router.replace('/login');
        }
      });
    }
    return Promise.reject(error);
  }
);
